import {
    FETCH_SMSCONFIG,
    FETCH_SMSCONFIG_SUCCESS,
    FETCH_SMSCONFIG_FAILED,
    EDIT_SMSCONFIG
  } from "../store/types";
  import { firebase } from '../config/configureFirebase';
  import { get, set } from "firebase/database";
  import store from '../store/store';
  import AccessKey from '../other/AccessKey';
  import base64 from 'react-native-base64';
  import { patchUsersCacheUpsert } from './usersactions';

  export const fetchSMSConfig = () => async (dispatch) => {

    const {
      smsRef
    } = firebase;

    dispatch({
      type: FETCH_SMSCONFIG,
      payload: null,
    });
    try {
      const snapshot = await get(smsRef);
      if (snapshot.val()) {
        dispatch({
          type: FETCH_SMSCONFIG_SUCCESS,
          payload: snapshot.val(),
        });
      } else {
        dispatch({
          type: FETCH_SMSCONFIG_FAILED,
          payload: "Unable to fetch SMS Config details.",
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_SMSCONFIG_FAILED,
        payload: error.message,
      });
    }
  };

  export const editSmsConfig = (smsDetails) => (dispatch) => {
    const {
      smsRef
    } = firebase;   1
    dispatch({
      type: EDIT_SMSCONFIG,
      payload: null
    });
    set(smsRef, smsDetails);
  };

  // Marketing campaign: send a single platform's app download link via SMS to
  // a customer (typically an auto-created "Manual Rider" who never installed
  // the app). Calls the send_app_download_link_sms Cloud Function, which sends
  // the SMS AND records downloadLinkSentAt/Platform/SentBy on the user record.
  // On success we patch the users cache + Redux so the dashboard reflects the
  // sent-state immediately, without a full /users re-fetch (cost-conscious).
  export const sendAppDownloadLinkSms = (uid, mobile, platform, sentBy) => async () => {
    const { config } = firebase;
    const settings = store.getState().settingsdata.settings;
    const host = (typeof window !== 'undefined' && window.location && settings.CompanyWebsite === window.location.origin)
      ? window.location.origin
      : `https://${config.projectId}.web.app`;

    const response = await fetch(`${host}/send_app_download_link_sms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + base64.encode(config.projectId + ':' + AccessKey)
      },
      body: JSON.stringify({ uid, rawPhone: mobile, platform, sentBy })
    });

    const result = await response.json();
    if (!response.ok || !result.success) {
      throw new Error(result.message || 'SMS send failed');
    }

    // Cache/Redux patch only — no DB write here (the function already persisted
    // server-side) and no /users re-fetch.
    await patchUsersCacheUpsert(uid, {
      downloadLinkSentAt: Date.now(),
      downloadLinkPlatform: platform,
      downloadLinkSentBy: sentBy
    });
    return result;
  };